module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-11.a9fb51cf.mp3";